<form [formGroup]="changeEmailForm">
  <div class="modal-header">
    <h5 class="modal-title"><i class="fa fa-lg fa-user" aria-hidden="true"></i> Change email </h5> <span>Username: <input class="disabledUsernameInput" type="text" formControlName="username"></span>
    <button type="button" class="close btn" data-dismiss="modal" aria-label="Close" (click)="cancelModal()">
      <span aria-hidden="true"><i class="fa fa-times"></i></span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group d-flex justify-content-center">
      <mat-form-field class="user-input" >
        <input matInput required type="email" placeholder="Email" formControlName="email">
        <mat-error *ngIf="changeEmailForm.hasError('required', 'email')">
          Please enter an email address
        </mat-error>

        <mat-error *ngIf="changeEmailForm.hasError('email', 'email')">
          Enter a valid email address
        </mat-error>

      </mat-form-field>
    </div>
  </div>

  <div class="modal-footer">
    <button mat-raised-button color="primary" class="greyButton" type="submit" (click)="changeEmail()">
      Change email
    </button>
  </div>
</form>
